import React, { useState, useEffect } from "react";
import "./Posp.css";
import { connect, useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { addVahanData } from "../../Redux/actions/NumBikeation";
import {
  QuickQuote_Post,
  quick_quoteValues,
  setQuickQuoteValues,
  setQuickQuotePost,
} from "../../Redux/actions/CommercialSlice";
import { Previousinsurer } from "../../Redux/actions/CommercialSlice";
import { PospNavBar } from "../Navbar/PospNav";
import {
  Form,
  Input,
  Row,
  Col,
  AutoComplete,
  Button,
  DatePicker,
  Radio,
  Select,
  Upload,
  message,
} from "antd/lib";
import { PlusOutlined } from "@ant-design/icons";
import moment from "moment";
import axiosCommercial from "../../Redux/axios/AxiosCommercial";
import axiosInPosp from "../../Redux/axios/AxiosInPosp";
function PospCommercialMake(props) {
  // console.log("propss", props.preinslist);
  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();
  const [formLayout] = useState("vertical");
  const InsurerList = useSelector(
    (state) => state.commercialdetail?.previousInsurers
  );
  const commercialNum = useSelector(
    (state) => state?.commercialdetail?.commercialnum
  );
  const vechicleData = useSelector((state) => state?.common?.vahanData);
  const QuickPost = useSelector((state) => state?.commercialdetail?.quoteInput);
  const BikeMakeData = useSelector(
    (state) => state?.commercialdetail?.commerMakeData
  );
  const [loading, setLoading] = useState(false);
  const [bikeNumDetail, setBikeNumdeail] = useState(commercialNum);
  const [notExp, setnotExp] = useState(
    QuickPost?.currentPolicyExpired === "NotExpired" ? true : false
  );
  const [selectedDate, setSelectedDate] = useState("");
  const [NotSecure, setNotSecure] = useState(
    QuickPost?.previous_policy_type === "Not-Secure" ? false : true
  );
  const [options, setOptions] = useState([]);
  const [MakeData, setMakeData] = useState([]);
  const [ModalData, setModalData] = useState([]);
  const [VarientData, setVarientData] = useState([]);
  const [Makeoptions, setMakeoptions] = useState([]);
  const [VarientOption, setVarientOptions] = useState([]);
  // const [InsurerList, setInsurerList] = useState([]);
  const [CommerMake, setCommerMake] = useState("");
  const [commerModel, setModelSearch] = useState("");
  const [commercialVarient, setSelectVarient] = useState("");
  const [saveloading, setIsaveloading] = useState(false);
  const [visAddon, setVisAddon] = useState(false);
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [isNcb, setIsNcb] = useState(
    QuickPost?.isclaim ? QuickPost?.isclaim : false
  );
  const [typesData, setTypedata] = useState([]);
  const [TypeOption, setTypeOption] = useState([]);
  const [comVehicleType, setVehicleType] = useState("");
  const [comTypeName, setcomTypeName] = useState(
    QuickPost?.typesData === "PASSENGER CARRYING VEHICLE"
      ? "PASSENGER CARRYING VEHICLE"
      : ""
  );
  const [AadharfileList, setAadharfileList] = useState([]);
  const [PanfileList, setPanfileList] = useState([]);
  const [InspecfileList, setInspecfileList] = useState([]);
  const [CpExpValue, setCpExpValue] = useState(
    QuickPost?.currentPolicyExpired ? QuickPost?.currentPolicyExpired : ""
  );
  const [ReqPolicyValue, setReqPolicyValue] = useState(
    QuickPost?.required_policy_type ? QuickPost?.required_policy_type : ""
  );
  const [PrevPolicyValue, setPrevPolicyValue] = useState(
    QuickPost?.previous_policy_type ? QuickPost?.previous_policy_type : ""
  );
  const [InspectReq, setInspectReq] = useState("");
  const [ShowMore, setShowMore] = useState(false);

  useEffect(() => {
    // dispatch(Previousinsurer())
    //   .then((res) => {
    //     console.log("previous insurer", res);
    //     setInsurerList(res);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  }, [dispatch]);
  useEffect(() => {
    console.log(bikeNumDetail);
    form.setFieldsValue({
      registrationYear: moment(vechicleData?.registration_date),
    });
  }, [vechicleData]);
  const formItemLayout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
  };
  useEffect(() => {
    axiosCommercial
      .get("commercial_vehicle_type")
      .then((res) => {
        console.log(res);
        const resp = res.data.data;
        console.log(resp);
        const typeData = resp.map((item) => item);
        console.log("resp", typeData);
        const filteredOptions = typeData.map((option) =>
          option.types.toUpperCase()
        );
        console.log("filteredOptions", filteredOptions);
        setTypedata(filteredOptions);
        setTypeOption(filteredOptions);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const handleSearchcomMake = (searchText) => {
    setIsaveloading(true);
    const filteredOptions = TypeOption.filter((option) =>
      option.toLowerCase().includes(searchText.toLowerCase())
    );
    console.log(filteredOptions);
    setTypedata(filteredOptions);
  };
  const onSelectCommeType = (data) => {
    console.log("onSelect", data);
    setcomTypeName(data);
    setVehicleType(data);
    // setIsaveloading(false);
    form.setFieldsValue({
      commercialMake: "",
      commercialModel: "",
      commercialVarient: "",
    });
  };
  useEffect(() => {
    axiosCommercial
      .get(`commercial_vehicle_make/${comVehicleType}`)
      .then((res) => {
        console.log(res);
        const resp = res.data.data;
        console.log(resp);
        const makeData = resp.map((item) => item);
        // console.log("resp", makeData);
        setMakeoptions(makeData);
        setMakeData(makeData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [comVehicleType]);
  const handleSearchMake = (searchText) => {
    setIsaveloading(true);
    const filteredOptions = Makeoptions.filter((option) =>
      option.toLowerCase().includes(searchText.toLowerCase())
    );
    console.log(filteredOptions);
    setMakeData(filteredOptions);
  };

  const onSelectMake = (data) => {
    console.log("onSelect", data);
    setCommerMake(data);
    const updatedVahanData = {
      ...vechicleData,
      maker_description: data,
    };
    dispatch(addVahanData(updatedVahanData));
    setIsaveloading(false);
    form.setFieldsValue({
      commercialModel: "",
      commercialVarient: "",
    });
  };

  useEffect(() => {
    axiosCommercial
      .get(`vehicle_model/${CommerMake}`)
      .then((res) => {
        console.log(res);
        const resp = res.data.data;
        console.log(resp);
        const modelData = resp.map((item) => item);
        // console.log("resp", modelData);
        setOptions(modelData);
        setModalData(modelData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [CommerMake]);

  const handleSearch = (searchText) => {
    setIsaveloading(true);
    const filteredOptions = options.filter((option) =>
      option.toLowerCase().includes(searchText.toLowerCase())
    );
    setModalData(filteredOptions);
  };

  const onSelect = (data) => {
    console.log("onSelect", data);
    setModelSearch(data);
    setIsaveloading(false);
    const updatedVahanData = {
      ...vechicleData,
      maker_model: data,
    };
    dispatch(addVahanData(updatedVahanData));
    form.setFieldsValue({
      commercialVarient: "",
    });
  };
  useEffect(() => {
    axiosCommercial
      .get(`vehicle_variant/${commerModel}`)
      .then((res) => {
        console.log(res);
        const resp = res.data.data;
        console.log(resp);
        const varientData = resp.map((item) => item);
        // console.log("resp", varientData);
        setVarientOptions(varientData);
        setVarientData(varientData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [commerModel]);

  const handleSearchVarient = (searchText) => {
    setIsaveloading(true);
    searchText = searchText.toUpperCase();
    form.setFieldsValue({ commercialVarient: searchText });
    const filteredOptions = VarientOption.filter((option) =>
      option.toLowerCase().includes(searchText.toLowerCase())
    );
    setVarientData(filteredOptions);
  };
  // console.log("comTypeName", comTypeName);
  // console.log("comVehicleType", comVehicleType);
  const onSelectVarient = (data) => {
    console.log("onSelect", data);
    const updatedVahanData = {
      ...vechicleData,
      variant: data,
    };
    dispatch(addVahanData(updatedVahanData));
    if (comTypeName === "PASSENGER CARRYING VEHICLE") {
      const parts = data.split("/");
      const secondPart = parts.slice(2).join("/");
      const result = secondPart.split(" ")[0];
      const cleanedResult = result.replace(/[()]/g, "");
      // console.log(cleanedResult);
      form.setFieldsValue({
        seat_capacity: `${cleanedResult} + 1`,
      });
    } else if (comTypeName === "GOODS COMMERCIAL VEHICLE") {
      const inputString = data;
      const parts = inputString.split("/");
      const numberPart = parts[1];
      console.log(numberPart);
      form.setFieldsValue({
        vehicle_gross_weight: numberPart,
      });
    }
  };

  const buttonItemLayout = {
    wrapperCol: {
      span: 24,
    },
  };

  const onDateChange = (date, dateString) => {
    console.log(date);
    console.log(dateString);
    //setRegDate(dateString)
  };
  const handleInputChange = (e) => {
    setIsaveloading(true);
    e.target.value = e.target.value.toUpperCase();
    setBikeNumdeail({
      ...bikeNumDetail,
      bike_number: e.target.value.toUpperCase(),
    });
    form.setFieldsValue({ commercial_vehicle_number: e.target.value });
    setIsaveloading(false);
  };
  console.log(bikeNumDetail);

  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    console.log(e.target.value);
    if (e.target.value === "Not-Secure") {
      setNotSecure(false);
    } else if (e.target.value === "Bundled") {
      // setproductCode(e.target.value)
      setNotSecure(true);
    } else {
      setNotSecure(true);
    }
  };

  const disabledDate = (current) => {
    const currentDate = moment();
    const fiveMonthsFromNow = moment().add(25, "week");
    return (
      current &&
      (current < currentDate.endOf("day") ||
        current > fiveMonthsFromNow.endOf("day"))
    );
  };

  const handleDateChange = (date, dateString) => {
    console.log(date);
    console.log("dateString", dateString);
    setSelectedDate(dateString);
  };
  console.log(selectedDate);

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    form.scrollToField(errorInfo.errorFields[0].name);
  };
  const isuser = JSON.parse(localStorage.getItem("vibeUser"));

  const onReqInsurerChange = (value) => {
    console.log(value);
    const limitedValues = value.slice(0, 3);
    console.log(limitedValues);
    form.setFieldsValue({ required_insurers: limitedValues });
  };
  const onAddonselect = (e) => {
    setSelectedAddons(e);
  };
  const onaddonchange = (e) => {
    console.log(e.target.value);
    if (e.target.value === "Yes") {
      setVisAddon(true);
      // selectedAddons([])
    } else if (e.target.value === "No") {
      setVisAddon(false);
    }
  };
  const OnClaimchange = (e) => {
    console.log(e.target.value);
    if (e.target.value === true) {
      setIsNcb(true);
    } else if (e.target.value === false) {
      setIsNcb(false);
    }
  };
  console.log(isNcb);
  const onReqTypeChange = (e) => {
    console.log("onReqTypeChange", e.target.value);
    setReqPolicyValue(e.target.value);
    setInspectReq("");
  };
  const onPrevPolChange = (e) => {
    console.log("onPrevPolChange", e.target.value);
    console.log(e.target.value);
    setPrevPolicyValue(e.target.value);
    setInspectReq("");
    if (e.target.value === "Not-Secure") {
      setNotSecure(false);
      setCpExpValue("");
    } else if (e.target.value === "Bundled") {
      // setproductCode(e.target.value)
      setNotSecure(true);
    } else {
      setNotSecure(true);
    }
  };
  const onExpChange = (e) => {
    console.log(e.target.value);
    setCpExpValue(e.target.value);
    setnotExp(e.target.value === "NotExpired");
    setInspectReq("");
  };
  const AadharProps = {
    multiple: false,
    accept: "application/pdf, .jpg, .png",
    beforeUpload: (file) => {
      setAadharfileList([...AadharfileList, file]);
      return false;
    },
    onRemove: (file) => {
      const index = AadharfileList.indexOf(file);
      const newFileList = AadharfileList.slice();
      newFileList.splice(index, 1);
      setAadharfileList(newFileList);
    },
    AadharfileList,
  };
  const PanProps = {
    multiple: false,
    accept: "application/pdf, .jpg, .png",
    beforeUpload: (file) => {
      setPanfileList([...PanfileList, file]);
      return false;
    },
    onRemove: (file) => {
      const index = PanfileList.indexOf(file);
      const newFileList = PanfileList.slice();
      newFileList.splice(index, 1);
      setPanfileList(newFileList);
    },
    PanfileList,
  };

  const InspectionProps = {
    multiple: true,
    accept: ".jpg, .png",
    beforeUpload: (file) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        file.thumbUrl = reader.result;
        setInspecfileList((prevList) => {
          const updatedList = [...prevList, file];
          // form.setFieldsValue({ inspection_images: updatedList });
          // form.validateFields(["inspection_images"]);
          return updatedList;
        });
      };
      return false;
    },
    onRemove: (file) => {
      setInspecfileList((prevList) => {
        const newFileList = prevList.filter((item) => item.uid !== file.uid);
        // form.setFieldsValue({ inspection_images: newFileList });
        // form.validateFields(["inspection_images"]);
        return newFileList;
      });
    },
    fileList: InspecfileList,
    // onPreview: handlePreview,
  };

  const onFinish = (values) => {
    console.log("values", values);

    values.seat_capacity =
      comTypeName === "PASSENGER CARRYING VEHICLE"
        ? values.seat_capacity
        : null;
    values.vehicle_gross_weight =
      comTypeName === "GOODS COMMERCIAL VEHICLE"
        ? values.vehicle_gross_weight
        : null;
    console.log("values?.seat_capacity", values?.seat_capacity);
    values.Addons = values?.required_addons === "No" ? null : values?.Addons;
    const productcode = values.previous_policy_type;
    const registrationDate = moment(values.registrationDate).format(
      "YYYY-MM-DD"
    );
    const regDate = new Date(registrationDate);
    regDate.setFullYear(regDate.getFullYear() + 5);
    values.registrationYear = moment(values.registrationYear).format(
      "YYYY-MM-DD"
    );
    console.log(values.registrationYear);
    setLoading(true);
    // values.ncbvalue = "0";
    if (isuser !== null) {
      var is_POSP = isuser.isPOSP === true ? 1 : 0;
      var posp_id = isuser.isPOSP === true ? isuser.pospid : "";
    } else {
      is_POSP = 0;
      posp_id = "";
    }
    let currentTP = {
      currentThirdPartyPolicyNumber:
        productcode === "SAOD" || productcode === "Bundled"
          ? vechicleData?.insurance_policy_number
          : null,
      currentThirdPartyPolicyInsurerCode:
        productcode === "SAOD" || productcode === "Bundled"
          ? values.insuranceProductCode
          : null,
      currentThirdPartyPolicyStartDateTime:
        productcode === "SAOD" || productcode === "Bundled"
          ? moment(values.registrationDate).format("YYYY-MM-DD")
          : null,
      currentThirdPartyPolicyExpiryDateTime:
        productcode === "SAOD" || productcode === "Bundled"
          ? moment(regDate).format("YYYY-MM-DD")
          : null,
    };
    let post = {
      firstName: vechicleData?.owner_name,
      licensePlateNumber: values?.commercial_vehicle_number,
      Chasis: vechicleData?.vehicle_chasi_number,
      Engine: vechicleData?.vehicle_engine_number,
      fuel_type: vechicleData?.fuel_type
        ? vechicleData?.fuel_type
        : BikeMakeData?.fuel_type,
      address: vechicleData?.present_address,
      previousPolicyNumber:
        productcode === "Not-Secure"
          ? ""
          : vechicleData?.insurance_policy_number
            ? vechicleData?.insurance_policy_number
            : "",
      previous_policy_type: values?.previous_policy_type,
      policyHolderType: values?.PolicyHolderType,
      required_policy_type: values?.required_policy_type,
      required_insurer: values?.required_insurer,
      isVehicleNew: 0,
      product_type: values?.typesData,
      make: values?.commercialMake,
      model: values?.commercialModel,
      variant: values?.commercialVarient,
      previousPolicyExpiryDate:
        productcode === "Not-Secure"
          ? ""
          : moment(values.previousPolicyExpiryDate).format("YYYY-MM-DD"),
      registrationDate: values.registrationYear,
      isPreviousInsurerKnown: productcode === "Not-Secure" ? 0 : 1, //0 r 1 int
      previousInsurerCode:
        productcode === "Not-Secure" ? "" : values?.previousInsurerCode,
      originalPreviousPolicyType:
        productcode === "SAOD"
          ? "1OD_0TP"
          : productcode === "Bundled"
            ? "1OD_5TP"
            : "",
      currentThirdPartyPolicy:
        productcode === "SAOD" || productcode === "Bundled" ? currentTP : "",
      isClaimInLastYear: values?.isclaim,
      previousNoClaimBonus: values?.isclaim === true ? null : values?.ncbvalue,
      // pincode: '587316',
      isPOSP: true,
      insurance_id: commercialNum?.commercial_insurance_id,
      // quote_request_from: values?.quote_request_from,
      // pospId: posp_id,
    };
    console.log("post", post);
    console.log("values", values);
    const formData = new FormData();
    Object.keys(post).forEach((key) => {
      formData.append(key, post[key]);
    });
    values?.required_insurers.forEach((insur, index) => {
      console.log(insur, index);
      formData.append(`required_insurers[${index}]`, insur);
    });
    formData.append("aadhaar_copy", AadharfileList[0]);
    formData.append("pancard_copy", PanfileList[0]);
    if (InspecfileList?.length > 0) {
      InspecfileList?.forEach((file, index) => {
        console.log(file, index);
        formData.append(`inspection_images[${index}]`, file);
      });
    } else {
      formData.append("inspection_images", null);
    }
    dispatch(setQuickQuotePost(post));
    dispatch(setQuickQuoteValues(values));
    axiosInPosp
      .post("v1/posp/quick_quotes", formData)
      .then((res) => {
        console.log(res);
        console.log(res?.status);
        // if (res?.status === 201) {
        const data = res?.data;
        console.log(data);
        console.log("inside if condition");
        message.success("Quote request send successfully");
        // dispatch(OnSendReq(updateQuoteReq));
        setLoading(false);
        history.push("/");
      })
      .catch((err) => {
        console.log(err?.response);
        // if (err.response.data.message == "Unauthenticated.") {
        //   dispatch((dispatch) => {
        //     dispatch({ type: "LOGOUT_POSP" });
        //   });
        //   history.push("/");
        // }
        setLoading(false);
      });
  };

  return (
    <>
      <PospNavBar />
      <section
        className="bg-light py-4"
        style={{ minHeight: "calc(100vh - 50px)" }}
      >
        <div className="container">
          <div className="row align-items-start justify-content-between">
            <div className="col-xl-12 col-lg-12 px-3 col-md-12  bike-info-quotebef">
              <div
                className="h6 text-blue py-3 text-center mb-0"
                style={{ fontSize: "25px", fontWeight: "700" }}
              >
                COMMERCIAL VEHICLE DETAILS
              </div>
              <Form
                layout={formLayout}
                form={form}
                style={{ width: "100%" }}
                //requiredMark={false}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
              >
                <Row gutter={12}>
                  <Col span={12}>
                    <Form.Item
                      label="Vehicle Number"
                      name="commercial_vehicle_number"
                      rules={[
                        {
                          pattern: /^[A-Z]{2}[0-9]{1,2}[A-Z]{1,2}[0-9]{3,4}$/i,
                          message: "Invalid Vehicle No",
                        },
                        { required: true, message: "Enter Vehicle No" },
                      ]}
                      initialValue={commercialNum?.commercial_vehicle_number}
                    >
                      <Input
                        onChange={handleInputChange}
                        placeholder="Enter Vehicle Number (eg. DL1SAB1234)"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="typesData"
                      label="Select Vehicle Types"
                      rules={[
                        {
                          required: true,
                          message: "Please Select Types",
                        },
                      ]}
                      initialValue={QuickPost?.typesData}
                    >
                      <AutoComplete
                        options={typesData?.map((option, index) => ({
                          key: index,
                          value: option,
                        }))}
                        onSelect={onSelectCommeType}
                        onSearch={handleSearchcomMake}
                        placeholder="GOODS, PASSENGER..."
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="commercialMake"
                      label="Select Make"
                      rules={[
                        {
                          required: true,
                          message: "Please Select Make",
                        },
                      ]}
                      initialValue={vechicleData?.maker_description}
                    >
                      <AutoComplete
                        //defaultValue={bikeNumDetail?.maker_description}
                        options={MakeData?.map((option, index) => ({
                          key: index,
                          value: option,
                        }))}
                        onSelect={onSelectMake}
                        onSearch={handleSearchMake}
                        placeholder="Enter Make"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="commercialModel"
                      label="Select Model"
                      rules={[
                        {
                          required: true,
                          message: "Please Select Model",
                        },
                      ]}
                      initialValue={vechicleData?.maker_model}
                    >
                      <AutoComplete
                        //defaultValue={bikeNumDetail?.maker_description}
                        options={ModalData?.map((option, index) => ({
                          key: index,
                          value: option,
                        }))}
                        onSelect={onSelect}
                        onSearch={handleSearch}
                        placeholder="Enter Model"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="commercialVarient"
                      label="Select Variant"
                      rules={[
                        {
                          required: true,
                          message: "Please Select Variant",
                        },
                      ]}
                      initialValue={vechicleData?.variant}
                    >
                      <AutoComplete
                        options={VarientData?.map((option, index) => ({
                          key: index,
                          value: option,
                        }))}
                        onSelect={onSelectVarient}
                        onSearch={handleSearchVarient}
                        placeholder="Enter Variant"
                      />
                    </Form.Item>
                  </Col>
                  {comTypeName === "PASSENGER CARRYING VEHICLE" ? (
                    <Col span={6}>
                      <Form.Item
                        name="seat_capacity"
                        label="Seating Capacity"
                        rules={[
                          {
                            required: true,
                            message: "Please Enter Seating Capacity",
                          },
                        ]}
                        initialValue={QuickPost?.seat_capacity}
                      >
                        <Input
                          // type="number"
                          style={{ padding: "2px 8px" }}
                          placeholder="Vehicle Seating Capacity"
                        ></Input>
                      </Form.Item>
                    </Col>
                  ) : null}
                  <Col
                    span={comTypeName === "PASSENGER CARRYING VEHICLE" ? 6 : 12}
                  >
                    <Form.Item
                      label="Registration Year"
                      name="registrationYear"
                      rules={[
                        {
                          required: true,
                          message: "please input Registration Year",
                        },
                      ]}
                    >
                      <DatePicker
                        style={{ width: "100%", padding: "8px" }}
                        format="YYYY-MM-DD"
                        onChange={onDateChange}
                        placeholder="Select Registration Date"
                      />
                    </Form.Item>
                  </Col>
                  {comTypeName === "GOODS COMMERCIAL VEHICLE" ? (
                    <Col span={6}>
                      <Form.Item
                        name="vehicle_gross_weight"
                        label="Vehicle Gross weight"
                        rules={[
                          {
                            required: true,
                            message: "Please Enter Vehicle Gross weight",
                          },
                        ]}
                        initialValue={QuickPost?.vehicle_gross_weight}
                      >
                        <Input
                          // type="number"
                          style={{ padding: "2px 8px" }}
                          placeholder="Enter Vehicle Gross weight"
                        ></Input>
                      </Form.Item>
                    </Col>
                  ) : null}
                  <Col span={6}>
                    <Form.Item
                      name="PolicyHolderType"
                      label="Vehicle Owned By ?"
                      rules={[
                        {
                          required: true,
                          message: "Please select PolicyHolderType",
                        },
                      ]}
                      initialValue={
                        QuickPost?.PolicyHolderType
                          ? QuickPost?.PolicyHolderType
                          : "INDIVIDUAL"
                      }
                    >
                      <Select
                        //defaultValue='INDIVIDUAL'
                        placeholder="Select Type"
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        options={[
                          {
                            value: "INDIVIDUAL",
                            label: "INDIVIDUAL",
                          },
                          {
                            value: "COMPANY",
                            label: "COMPANY",
                          },
                        ]}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label="Driving Licence ?"
                      name="driverlicence"
                      rules={[
                        {
                          required: true,
                          message: "Please select",
                        },
                      ]}
                      initialValue={
                        QuickPost?.driverlicence
                          ? QuickPost?.driverlicence
                          : "Yes"
                      }
                    >
                      <Select
                        placeholder="Select a person"
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        options={[
                          {
                            value: "Yes",
                            label: "Yes",
                          },
                          {
                            value: "No",
                            label: "No",
                          },
                        ]}
                      />
                    </Form.Item>
                  </Col>
                  <Col
                    span={comTypeName === "GOODS COMMERCIAL VEHICLE" ? 6 : 12}
                  >
                    <Form.Item
                      name="Additionl_covers"
                      label="Additional Covers"
                      rules={[
                        {
                          required: true,
                          message: "Please select Additional Covers",
                        },
                      ]}
                      initialValue={
                        QuickPost?.Additionl_covers === null
                          ? ""
                          : QuickPost?.Additionl_covers
                      }
                    >
                      <Select
                        mode="multiple"
                        className="req-pol-select"
                        maxTagCount="responsive"
                        maxTagTextLength={14}
                        placeholder="Select Additional Covers"
                        // onChange={onAddonselect}
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        options={[
                          {
                            value: "BI-FUEL KIT (CNG)",
                            label: "BI-FUEL KIT (CNG)",
                          },
                          {
                            value:
                              "COMPULSARY PERSONAL ACCIDENT (PA TO OWNER DRIVER)",
                            label:
                              "COMPULSARY PERSONAL ACCIDENT (PA TO OWNER DRIVER)",
                          },
                          {
                            value: "IMT 23",
                            label: "IMT 23",
                          },
                          {
                            value: "LEGAL LIABILITY PAID TO CLEANER",
                            label: "LEGAL LIABILITY PAID TO CLEANER",
                          },
                          {
                            value: "LEGAL LIABILITY PAID TO COOLIE",
                            label: "LEGAL LIABILITY PAID TO COOLIE",
                          },
                        ]}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={8}>
                    {/* <div className="h6 text-blue mb-3 mb-3">
                      Required Policy Type
                    </div> */}
                    <Form.Item
                      {...formItemLayout}
                      name="required_policy_type"
                      label="Required Policy Type"
                      rules={[
                        {
                          required: true,
                          message: "Please select Policy Type",
                        },
                      ]}
                      initialValue={QuickPost?.required_policy_type}
                    >
                      <Radio.Group
                        className="py-3 px-3 bg-white ant-radio-layout radio-border-form"
                        onChange={onReqTypeChange}
                      >
                        <Radio value="Comprehensive">Comprehensive</Radio>
                        <Radio value="Third-Party">Third-Party</Radio>
                        {/* <Radio value="SAOD">SAOD</Radio> */}
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    {/* <div className="h6 text-blue mb-3 mb-3">
                      Addons
                    </div> */}
                    <Form.Item
                      {...formItemLayout}
                      name="required_addons"
                      label="Addons"
                      rules={[
                        {
                          required: true,
                          message: "Please select Policy Type",
                        },
                      ]}
                      initialValue={QuickPost?.required_addons}
                    >
                      <Radio.Group
                        onChange={onaddonchange}
                        className="py-3 px-3 bg-white ant-radio-layout radio-border-form"
                      >
                        <Radio value="Yes">Yes</Radio>
                        <Radio value="No">No</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  {visAddon === true ? (
                    <Col span={6}>
                      {/* <div className="h6 text-blue mb-3">
                    Select Addons
                    </div> */}
                      <Form.Item
                        name="Addons"
                        label="Select Addons"
                        rules={[
                          {
                            required: true,
                            message: "Please select Addons",
                          },
                        ]}
                        initialValue={
                          QuickPost?.Addons === null ? "" : QuickPost?.Addons
                        }
                      >
                        <Select
                          mode="multiple"
                          className="req-pol-select"
                          maxTagCount="responsive"
                          placeholder="Select Addons"
                          onChange={onAddonselect}
                          filterOption={(input, option) =>
                            (option?.label ?? "")
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          options={[
                            {
                              value: "CONSUMABLE",
                              label: "CONSUMABLE",
                            },
                            {
                              value: "ENGINE PROTECTOR",
                              label: "ENGINE PROTECTOR",
                            },
                            {
                              value: "ROAD SIDE ASSISTANCE",
                              label: "ROAD SIDE ASSISTANCE",
                            },
                            {
                              value: "ZERO DEPRECIATION",
                              label: "ZERO DEPRECIATION",
                            },
                          ]}
                        />
                      </Form.Item>
                    </Col>
                  ) : null}
                  <Col span={visAddon === true ? 6 : 12}>
                    {/* <div className="h6 text-blue mb-3">
                      Select Required insurer
                    </div> */}
                    <Form.Item
                      // {...formItemLayout}
                      name="required_insurers"
                      label="Select Required insurer"
                      rules={[
                        {
                          required: true,
                          message: "Please select previous insurer",
                        },
                      ]}
                      initialValue={QuickPost?.required_insurers}
                    >
                      <Select
                        onChange={onReqInsurerChange}
                        maxTagTextLength={15}
                        // maxTagCount={3}
                        maxTagCount="responsive"
                        className="req-pol-select"
                        mode="multiple"
                        style={{
                          width: "100%",
                        }}
                        placeholder="Select any 3 insurer"
                        showSearch
                        filterOption={(input, option) =>
                          option.label
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        options={InsurerList?.map((p) => ({
                          key: p.id,
                          value: p.name,
                          label: p.name,
                        }))}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={14}>
                    {/* <div className="h6 text-blue mb-3 mb-3">
                      Previous Policy Type
                    </div> */}
                    <Form.Item
                      {...formItemLayout}
                      name="previous_policy_type"
                      label="Previous Policy Type"
                      //className="form-item-bg"
                      rules={[
                        {
                          required: true,
                          message: "Please select Policy Type",
                        },
                      ]}
                      initialValue={QuickPost?.previous_policy_type}
                    >
                      <Radio.Group
                        className="py-3 px-3 bg-white ant-radio-layout radio-border-form"
                        // onChange={onChange}
                        onChange={onPrevPolChange}
                      >
                        <Radio value="Comprehensive">Comprehensive</Radio>
                        <Radio value="Third-Party">Third-Party</Radio>
                        <Radio value="Not-Secure">Not Secure</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  {NotSecure === true ? (
                    <>
                      <Col span={10}>
                        {/* <div className="h6 text-blue mb-3">
                          Select previous insurer
                        </div> */}
                        <Form.Item
                          {...formItemLayout}
                          label="Select previous insurer"
                          name="previousInsurerCode"
                          rules={[
                            {
                              required: true,
                              message: "Please select previous insurer",
                            },
                          ]}
                          initialValue={QuickPost?.previousInsurerCode}
                        >
                          <Select
                            placeholder="Select your option"
                            showSearch
                            filterOption={(input, option) =>
                              option.label
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            // onChange={handleChange}
                            options={props?.preinslist?.map((p) => ({
                              key: p.id,
                              value: p.name,
                              label: p.name,
                            }))}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={18}>
                        {/* <div className="h6 text-blue mb-3">
                        Have Your Current Policy Expired ?
                        </div> */}
                        <Form.Item
                          {...formItemLayout}
                          label="Have Your Current Policy Expired ?"
                          name="currentPolicyExpired"
                          rules={[
                            {
                              required: true,
                              message: "Please select Policy Expired",
                            },
                          ]}
                          initialValue={QuickPost?.currentPolicyExpired}
                        >
                          <Radio.Group
                            className="py-3 px-3 bg-white ant-radio-layout radio-border-form"
                            style={{ width: "100%" }}
                            onChange={onExpChange}
                            // onChange={(e) => {
                            //   setnotExp(e.target.value === "NotExpired");
                            // }}
                            defaultValue={
                              notExp === true ? "NotExpired" : undefined
                            }
                          >
                            <Radio value="NotExpired">Not Expired</Radio>
                            <Radio value="Expired Within 90 Days">
                              Expired Within 90 Days
                            </Radio>
                            <Radio value="Expired More Than 90 Days">
                              Expired More Than 90 Days
                            </Radio>
                            <Radio value="I dont Remember">
                              I don't Remember
                            </Radio>
                          </Radio.Group>
                        </Form.Item>
                      </Col>
                      {notExp === true ? (
                        <Col span={6}>
                          {/* <div className="h6 text-blue mb-3">Previous Policy Expiry Date</div>  */}
                          <Form.Item
                            {...formItemLayout}
                            //className="form-item-bg"
                            label="Previous Policy Expiry Date"
                            name="previousPolicyExpiryDate"
                            rules={[
                              {
                                required: true,
                                message: "Please select Date",
                              },
                            ]}
                            initialValue={
                              QuickPost?.previousPolicyExpiryDate
                                ? moment(QuickPost?.previousPolicyExpiryDate)
                                : null
                            }
                          >
                            <DatePicker
                              style={{ width: "100%", padding: "9px 8px" }}
                              // defaultValue={moment(bikeResult.insurance_upto)}
                              disabledDate={disabledDate}
                              onChange={handleDateChange}
                              format="YYYY-MM-DD"
                              placeholder="Select Expiry Date"
                            />
                          </Form.Item>
                        </Col>
                      ) : null}
                    </>
                  ) : null}
                  <Col span={6}>
                    {/* {!notExp ? null : (
                      <div className="h6 text-blue mb-3">Previous PA Cover of Rs 15 Lakh ?</div>
                    )} */}
                    {/* <div className="h6 text-blue mb-3">Previous PA Cover of Rs 15 Lakh ?</div> */}
                    <Form.Item
                      {...formItemLayout}
                      //className="radio-border-form"
                      label="Previous PA Cover of Rs 15 Lakh ?"
                      name="paCover"
                      rules={[
                        {
                          required: !NotSecure ? false : true,
                          message: "Please select",
                        },
                      ]}
                      initialValue={
                        QuickPost?.paCover ? QuickPost?.paCover : "No"
                      }
                    >
                      <Radio.Group
                        //defaultValue='No'
                        disabled={!NotSecure}
                        className="py-3 px-3 bg-white ant-radio-layout radio-border-form"
                        style={{
                          width: "100%",
                        }}
                      >
                        <Radio value="Yes">Yes</Radio>
                        <Radio value="No">No</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    {/* <div className="h6 text-blue mb-3">Owner Change</div> */}
                    <Form.Item
                      {...formItemLayout}
                      //className="radio-border-form"
                      label="Owner Change"
                      name="ownerChange"
                      rules={[
                        {
                          required: !NotSecure ? false : true,
                          message: "Please select",
                        },
                      ]}
                      initialValue={
                        QuickPost?.ownerChange ? QuickPost?.ownerChange : "Yes"
                      }
                    >
                      <Radio.Group
                        //defaultValue='Yes'
                        disabled={!NotSecure}
                        className="py-3 px-3 bg-white ant-radio-layout radio-border-form"
                        style={{
                          width: "100%",
                        }}
                      >
                        <Radio value="Yes">Yes</Radio>
                        <Radio value="No">No</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    {/* <div className="h6 text-blue mb-3">Claim Made In Expiry Policy</div> */}
                    <Form.Item
                      {...formItemLayout}
                      //className="radio-border-form"
                      label="Claim Made In Expiry Policy"
                      name="isclaim"
                      rules={[
                        {
                          required: !NotSecure ? false : true,
                          message: "Please select",
                        },
                      ]}
                      initialValue={
                        QuickPost?.isclaim ? QuickPost?.isclaim : false
                      }
                    >
                      <Radio.Group
                        disabled={!NotSecure}
                        className="py-3 px-3 bg-white ant-radio-layout radio-border-form"
                        style={{
                          width: "100%",
                        }}
                        onChange={OnClaimchange}
                      >
                        <Radio value={true}>Yes</Radio>
                        <Radio value={false}>No</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  {isNcb === false ? (
                    <Col span={notExp === true ? 6 : 7}>
                      {/* <div className="h6 text-blue mb-3">
                    Previous No Claim Bonus (NCB)
                  </div> */}
                      <Form.Item
                        {...formItemLayout}
                        //className="radio-border-form"
                        label="Previous No Claim Bonus(NCB)"
                        name="ncbvalue"
                        rules={[
                          {
                            required: true,
                            message: "Please select",
                          },
                        ]}
                        initialValue={QuickPost?.ncbvalue}
                      >
                        <Select placeholder="NCB">
                          <Select.Option value="ZERO">0%</Select.Option>
                          <Select.Option value="TWENTY">20%</Select.Option>
                          <Select.Option value="TWENTY_FIVE">25%</Select.Option>
                          <Select.Option value="THIRTY_FIVE">35%</Select.Option>
                          <Select.Option value="FORTY_FIVE">45%</Select.Option>
                          <Select.Option value="FIFTY">50%</Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>
                  ) : null}
                  {(CpExpValue === "Expired More Than 90 Days" &&
                    ReqPolicyValue === "Comprehensive") ||
                    (ReqPolicyValue === "Comprehensive" &&
                      CpExpValue === "I dont Remember") ||
                    (CpExpValue === "I dont Remember" &&
                      ReqPolicyValue === "Standalone own damage") ||
                    (ReqPolicyValue === "Standalone own damage" &&
                      CpExpValue === "Expired More Than 90 Days") ||
                    (ReqPolicyValue === "Comprehensive" &&
                      PrevPolicyValue === "Not-Secure") ||
                    (ReqPolicyValue === "Standalone own damage" &&
                      PrevPolicyValue === "Not-Secure") ? (
                    <Col span={8}>
                      <Form.Item
                        {...formItemLayout}
                        label="Inspection required"
                        name="breakinRequired"
                        rules={[
                          {
                            required: true,
                            message: "Please select",
                          },
                        ]}
                      // initialValue={
                      //   QuickPost?.breakinRequired ? QuickPost?.breakinRequired : "No"
                      // }
                      >
                        <Radio.Group
                          // disabled={!NotSecure}
                          className="py-3 px-3 bg-white ant-radio-layout radio-border-form"
                          style={{
                            width: "100%",
                          }}
                          onChange={(e) => setInspectReq(e.target.value)}
                        >
                          <Radio value="Yes">Yes</Radio>
                          <Radio value="No">No</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </Col>
                  ) : null}
                  {InspectReq === "Yes" ? (
                    <Col span={4}>
                      <Form.Item
                        name="inspection_images"
                        label="Inspection Photos"
                        rules={[
                          {
                            required: true,
                            message: "Please Upload Inspection Images",
                          },
                        ]}
                      >
                        <Upload
                          className={
                            ShowMore ? `inspect-view` : `inspect-upload`
                          }
                          {...InspectionProps}
                          maxCount={6}
                          listType="picture"
                        >
                          <Button
                            type="primary"
                            className="upload-kyc-btn"
                            icon={<PlusOutlined />}
                          >
                            Upload
                          </Button>
                        </Upload>
                      </Form.Item>
                      {InspecfileList?.length > 1 ? (
                        <p
                          className="mb-0 show-img-txt"
                          onClick={() => setShowMore(!ShowMore)}
                        >
                          {ShowMore
                            ? `View Less`
                            : `View More (${InspecfileList?.length - 1})`}
                        </p>
                      ) : null}
                    </Col>
                  ) : null}
                  <Col span={4}>
                    <Form.Item
                      name="aadhaar_copy"
                      label="Aadhaar Copy"
                      rules={[
                        { required: true, message: "Please Upload Rc Copy" },
                      ]}
                    >
                      <Upload {...AadharProps} maxCount={1}>
                        <Button
                          type="primary"
                          className="upload-kyc-btn"
                          icon={<PlusOutlined />}
                        >
                          Upload
                        </Button>
                      </Upload>
                    </Form.Item>
                  </Col>
                  <Col span={3}>
                    <Form.Item
                      name="pancard_copy"
                      label="Pancard Copy"
                      rules={[
                        { required: true, message: "Please Upload Rc Copy" },
                      ]}
                    >
                      <Upload {...PanProps} maxCount={1}>
                        <Button
                          type="primary"
                          className="upload-kyc-btn"
                          icon={<PlusOutlined />}
                        >
                          Upload
                        </Button>
                      </Upload>
                    </Form.Item>
                  </Col>
                </Row>
                <div
                  className="bg-white position-sticky bottom-0"
                  style={{ height: "50px" }}
                >
                  <div className="d-flex align-items-center justify-content-end container text-right py-2">
                    <Form.Item className="mb-0" {...buttonItemLayout}>
                      <Button
                        type="primary"
                        htmlType="submit"
                        loading={loading}
                      >
                        Next
                      </Button>
                    </Form.Item>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    product: state.vehicledetail.insuranceproduct,
    preinslist: state.vehicledetail.previnslist,
  };
};

export default connect(mapStateToProps)(PospCommercialMake);
